import type { MainLayoutContextValue } from '../components/layouts/MainPageLayout/MainLayoutContext';
import type { PortfolioAnalyticsPropertyResponseDto } from '@zg-rentals/ts-customer-analytics-client';

type GetGraphTitleParams = {
  graphName: string;
  regionsMapping: Record<number, string>;
  selectedRegionId: number;
  selectedFilters: MainLayoutContextValue['selectedFilters'];
  filteredProperties: Array<PortfolioAnalyticsPropertyResponseDto>;
};

export const getGraphTitle = ({
  graphName,
  regionsMapping,
  selectedRegionId,
  selectedFilters,
  filteredProperties,
}: GetGraphTitleParams): string => {
  const selectedProperty = filteredProperties.find(
    (property) => property.propertyDetails.listingAlias === selectedFilters.listingAlias,
  );

  if (selectedProperty) {
    return `${graphName} for ${selectedProperty.propertyDetails.listingName}`;
  }

  return regionsMapping[selectedRegionId] ? `${graphName} in ${regionsMapping[selectedRegionId]}` : graphName;
};
